import {gql} from "@apollo/client";

export const GET_IPS_VIOLATION_POINTS = gql`
  query getIPSViolationPoints {
  getIPSViolationPoints {
    violationId
    violationType {
      type
      name
    }
    analyte {
      name
      code
    }
    analyteGroup {
      name
      code
      analytes {
        name
        code
      }
    }
    ruleReference
    ipsPoints
    returnToComplianceMethod
    lastUpdatedDate
  }
}
`;

export const GET_VIOLATION_TYPES = gql`
  query getAllViolationTypes {
    getAllViolationTypes {
      type
      name
    }
  }
`;

export const GET_ANALYTES_AND_GROUPS = gql`
  query GetAllAnalyteGroupsAndAnalytes {
    getAllAnalyteGroupsAndAnalytes {
      analyteGroups {
        name
        code
        analytes {
          name
          code
        }
      }
      analytes {
        name
        code
      }
    }
  }
`;